import { Stat, Text, HStack } from '@chakra-ui/react'

export interface StatDelta { dir: 'up' | 'down'; value: string; tone?: 'success' | 'danger' }
export interface StatTileProps {
  label: string
  value: React.ReactNode
  delta?: StatDelta
  context?: string
  size?: 'md' | 'lg'
  align?: 'start' | 'center'
}

export function StatTile({ label, value, delta, context, size = 'md', align = 'start' }: StatTileProps) {
  return (
    <Stat.Root alignItems={align === 'center' ? 'center' : undefined}>
      <Stat.Label color="muted" fontSize="xs" textTransform="uppercase" letterSpacing="0.03em">
        {label}
      </Stat.Label>
      <Stat.ValueText fontSize={size === 'lg' ? '3xl' : '2xl'} fontWeight="600" letterSpacing="-0.02em" color="ink">
        {value}
      </Stat.ValueText>
      {!!delta && (
        <HStack gap={1} color={delta.tone === 'danger' ? 'danger.fg' : 'success.fg'} fontSize="sm" fontVariantNumeric="tabular-nums" data-testid="stat-delta">
          <Text as="span">{delta.dir === 'up' ? '▲' : '▼'}</Text>
          <Text as="span">{delta.value}</Text>
        </HStack>
      )}
      {!!context && <Text fontSize="xs" color="muted">{context}</Text>}
    </Stat.Root>
  )
}
